import {
    CREATE_COLLECTION,
    CREATE_COLLECTION_ITEM,
    DELETE_COLLECTION_ITEM,
    DELETE_FROM_ALL_COLLECTIONS,
    SET_COLLECTIONS
} from '../actions';

const reducer = (collections) => {

    const initialState = {
        collections
    };

    return (state = initialState, action = {}) => {
        let newState;
        const { type, data } = action;
        const { collections } = state;

        switch (type) {
            case CREATE_COLLECTION:
                newState = {
                    ...state,
                    collections: [...collections, data]
                };

                return newState;

            case CREATE_COLLECTION_ITEM:
                newState = {
                    ...state,
                    collections: collections.map((collection) => {
                        if (collection.id === data.id) {
                            return {
                                ...collection,
                                items: [...collection.items, data.item]
                            };
                        } else {
                            return collection;
                        }
                    })
                };

                return newState;

            case DELETE_COLLECTION_ITEM:
                newState = {
                    ...state,
                    collections: collections.map((collection) => {
                        if (collection.id === data.id) {
                            return {
                                ...collection,
                                items: collection.items.filter(({ id }) => id !== data.item.id)
                            };
                        } else {
                            return collection;
                        }
                    })
                };

                return newState;

            case DELETE_FROM_ALL_COLLECTIONS:
                const deletedIds = data.items.map(({ id }) => id);

                newState = {
                    ...state,
                    collections: collections.map((collection) => ({
                        ...collection,
                        items: collection.items.filter(({ id }) => !deletedIds.includes(id))
                    }))
                };

                return newState;

            case SET_COLLECTIONS:
                newState = {
                    collections: data.collections
                };

                return newState;

            default:
                return state;
        }
    };
};

export default reducer;
